module.exports = __webpack_public_path__ + "img/folders.88b9b50b.svg";